module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/katarzyna-stelmach-fd88a2cf1317bb39c867bfd10b284043.png";